import { ErrorResponse } from 'common/modules/app/errors';

/**
 * 内部用エラーの定義。
 *
 * 形式は、接頭辞 "E09" + 使用箇所ごとにユニークな番号 "xxxx" の７桁。
 */
export const InnerError = {
  /** 購入確認画面-一部重複エラー */
  purchaseSessionPartiallyDuplicated: {
    code: 'E090002',
    message: 'Partially duplicated.'
  } as ErrorResponse,

  /** 購入確認画面-購入手続きエラー */
  purchaseSessionPurchaseError: {
    code: 'E090003',
    message: 'Purchase error (unknown state value).'
  } as ErrorResponse,

  /** プラン詳細画面-クエリ指定されたプランが不正 */
  planDetailSpecifiedInvalidUrl: {
    code: 'E090004',
    message: 'Specified invalid url.'
  } as ErrorResponse,

  /** プラン詳細画面-プランが存在しない */
  planDetailNotFoundPurchasePlan: {
    code: 'E090005',
    message: 'There is not any available plans.'
  } as ErrorResponse,

  /** ログインが失敗 */
  loginFailed: {
    code: 'E090006',
    message: 'Login failed.'
  } as ErrorResponse,

  /** ログアウトが失敗 */
  logoutFailed: {
    code: 'E090007',
    message: 'Logout failed.'
  } as ErrorResponse,

  /** 購入確認画面-利用制限プラン重複購入エラー */
  purchaseSessionAdditionalError: {
    code: 'E090008',
    message: 'Purchases additional.'
  } as ErrorResponse,

  /** 購入確認画面-重複購入可能プラン重複エラー */
  purchaseSessionDuplicatePurchase: {
    code: 'E090009',
    message: 'duplicate purchase.'
  } as ErrorResponse
} as const;

/**
 *  購入確認画面-重複購入エラー
 *  planName: プラン名
 */
export function purchaseSessionAlreadyContracted(
  planName: string
): ErrorResponse {
  return {
    errors: [
      {
        code: planName,
        message: 'Already contracted.'
      }
    ]
  };
}

/**
 * 購入確認画面-重複購入不可エラー
 * planName: プラン名
 */
export function purchaseSessionDuplicatePurchased(
  planName: string
): ErrorResponse {
  return {
    errors: [
      {
        code: planName,
        message: 'Cannot Duplicate Purchase.'
      }
    ]
  };
}
